/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../../components/label";
import EditBankDetailForm from "../../../containers/EditBankDetailsForm";
import { NavLink } from "react-router-dom";
import appRoutes from "../../../routes/appRoutes";
import { connect } from "react-redux";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Model from "../../../components/modal";
import { addBankDetails } from "../../../apiRoutes";
import MakeAPICall from "../../../apiCalls/common";
import Loader from "../../../components/loader";
import AppConstant from "../../../constants";

class EditBankDetailPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stripePromise: loadStripe(AppConstant.stripeKey),
      stripeModel: false,
      stripeModelMsg: '',
      apiCall: null,
      apiLoading: false,
    }
  };

  onEditBankDetailSubmit = formValues => {
    this.setState({
      apiLoading: true
    });
    let formData = new FormData();  
    formData.append('bankAccountNumber', formValues.bankAccountNumber);
    formData.append('bankName', formValues.bankName);
    formData.append('bankAccountName', formValues.bankAccountName);
    formData.append('bankBSBNumber', formValues.bankBSBNumber);
    formData.append('stripeToken', formValues.stripeToken);

    formData.append('routing_number', formValues.routing_number);
    formData.append('account_number', formValues.account_number);
    formData.append('account_holder_name', formValues.account_holder_name);
    formData.append('account_holder_type', formValues.account_holder_type);

    let apiCallParam = {
      reqType: "POST",
      reqURL: addBankDetails,
      dataObj: formData,
      params: {},
      headers: {},
      successCallback: res => {
        this.setState({
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
        this.setState({
          apiLoading: false
        });
      },
      showPopUp: true,
      redirect: appRoutes.bankDetails
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  setStripeModel = (msg) => {
    this.setState({
      stripeModelMsg: msg,
      stripeModel: true
    });
  };

  closeStripeModel = (msg) => {
    this.setState({
      stripeModel: false
    });
  };

  render() {
    return (
      <Elements stripe={this.state.stripePromise}>
        <div className="row rounded p-3 bank-edit-page">
          <div className="col-sm-12 p-3">
            <NavLink
              to={appRoutes.bankDetails}
              className="insta-link-orange font-15 text-decoration-none"
              href="#"
            >
              <i className="fas fa-arrow-left"></i>{" "}
              <span className="ml-1 pt-1 back-btn-text">
                {" "}
                Back to Bank Details
            </span>
            </NavLink>
          </div>
          <div className="col-sm-12 p-3">
            <Label title="Update Bank Details" className="big" />
          </div>
          <div className="w-100 border"></div>

          <div className="col-sm-12 mt-4">
            <EditBankDetailForm onFormSubmit={this.onEditBankDetailSubmit} userData={this.props.auth} openStripeModel={this.setStripeModel} />
          </div>

          {/* Stripe Error Model */}
          <Model
            openModal={this.state.stripeModel}
            modalBodyContent={this.state.stripeModelMsg}
            okayText="Okay"
            cancelText="Okay"
            title="Instant Consult"
            useOneButton={true}
            okayEvent={this.closeStripeModel}
            cancelEvent={this.closeStripeModel}
          />

          {/* API Call */}
          <MakeAPICall apiParam={this.state.apiCall} />

           {/* Loader */}
         <Loader loading={this.state.apiLoading}/>

        </div>

      </Elements>
    );
  }
}

// export default EditBankDetailPage;

// get the store
const mapStateToProps = props => ({
  auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(EditBankDetailPage);

